b247.screenings = function() {




  var screenings = $('[data-screenings]');

  if (screenings.length) {

    screenings.each(function() {

      var target = $(this),
      list = target.find('[data-screenings-list]'),
      title = target.find('[data-screenings-title]'),
      items = list.find('[data-screenings-list-item]'),
      times = list.find('[data-screenings-time]');

      // create second result view

      var results = [];

      times.each(function() {

        var target = $(this),
        time = target.attr('data-screenings-time'),
		soldout = target.attr('data-soldout'),
        venue = target.closest('[data-screenings-list-item]').find('[data-screenings-list-item-title]').html(),
        venue_id = target.closest('[data-screenings-list-item]').find('[data-screenings-list-item-title]').attr('data-screenings-list-item-title');

        results.push([
          	time,
          	venue,
          	venue_id,
			soldout
        ]);

      });


      // sort items by date

      results.sort(function(a,b) {
        return a[0]-b[0];
      });

      // create new result set and output

      var test = {};

      $.each(results, function(i, l) {

        // get date

        var moment_date = moment(results[i][0], 'X');

        // create object for this date if it doesn't exist

        if (!test['date_' + moment_date.format('DDMMYYYY')]) { test['date_' + moment_date.format('DDMMYYYY')] = {}; }

        // get venue name and id

        var venue_name = results[i][1],
        venue_id = results[i][2];

        // create object for this venue id if it doesnt exist

        if (!test['date_' + moment_date.format('DDMMYYYY')]['venue_' + venue_id]) {

          test['date_' + moment_date.format('DDMMYYYY')]['venue_' + venue_id] = { 'id': venue_id, name: venue_name, times: [] };

        }

		var formatted_time = moment_date.format('hh:mm a');
		formatted_time = formatted_time.replace(/^0+/, '');

		if(results[i][3]=="true") {
			test['date_' + moment_date.format('DDMMYYYY')]['venue_' + venue_id].times.push('<span class="soldout">' + formatted_time + ' - Sold out</span>');
		} else {
			test['date_' + moment_date.format('DDMMYYYY')]['venue_' + venue_id].times.push(formatted_time)

		}



      });

      var second_result_view = '<ul class="screenings__list screenings__list--hide" data-screenings-list="dates">';

      $.each(test, function(i, l) {

        var date = i.replace('date_', ''),
        moment_date = moment(date, 'DDMMYYYY');

        second_result_view +=
        '<li class="screenings__item" data-screenings-list-item>' +
          '<p class="screenings__item__title" data-screenings-list-item-title>' + moment_date.format('ddd MMMM DD, YYYY') + '</p>' +
          '<div class="screenings__item__inner" data-screenings-list-item-content>' +
            '<div class="screenings__item__inner__inner">';

        var venues = l;

        $.each(venues, function(i, l) {

          second_result_view +=
          '<div class="screenings__item__row">' +
            '<p class="screenings__item__row__day">' + l.name +
            '<ul class="screenings__item__row__times">';

            $.each(l.times, function(i, l) {


              l = l.replace(/^0+/, '');

              second_result_view += '<li class="screenings__item__row__times__item">' + l + '</li>';

            });

          second_result_view +=
            '</ul>' +
          '</div>';

        });

        second_result_view +=
            '</div>' +
          '</div>' +
        '</li>';

      });

      second_result_view += '</ul>';

      target.append(second_result_view);

      // append title controls

      title.append(
        '<ul class="js-screenings-controls" data-screenings-controls>' +
          '<li class="js-screenings-controls__item js-screenings-controls__item--active" data-screenings-controls-item="cinema"><span class="js-screenings-controls__item__extra">View </span>by cinema</li>' +
          '<li class="js-screenings-controls__item" data-screenings-controls-item="dates"><span class="js-screenings-controls__item__extra">View </span> by date</li>' +
        '</ul>'
      );

    });

    $('[data-screenings-controls-item]').click(function() {

      var target = $(this),
      name = target.attr('data-screenings-controls-item');

      target.closest('[data-screenings-controls]').find('[data-screenings-controls-item]').removeClass('js-screenings-controls__item--active');
      target.addClass('js-screenings-controls__item--active');

      target.closest('[data-screenings]').find('[data-screenings-list]').addClass('screenings__list--hide');
      target.closest('[data-screenings]').find('[data-screenings-list="' + name + '"]').removeClass('screenings__list--hide');

      return false;

    });

    $('[data-screenings-list-item]').click(function() {

      $(this).toggleClass('screenings__item--open');
      return false;

    });

	$("[data-screenings-list-item]").on("click",".venue_link",function(e){
		e.stopPropagation();
		return true;
	})

  }

};
